'use client';

import { redirect, usePathname } from 'next/navigation';
import { defaultLocale } from '../i18n/constants';

export default function NotFound() {
  const pathname = usePathname();

  // If a user tries to access a page outside the i18n routing that does not exist, this function will be called.
  // Here we do not know the language and we cannot provide a localized 404 page. Instead we redirect to the default language.
  redirect(`/${defaultLocale}${pathname}`);
}
